import styled from "styled-components";
import { colors, font, radius } from "../../../../styles/theme/tokens";

// Поле-випадайка форми відмітки (нові стилі)
export const TopWrapper = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  padding: 14px 16px;
  border-radius: ${(props) => (props.$open ? `${radius.md} ${radius.md} 0 0` : radius.md)};
  border: ${(props) => (props.$open ? `2px solid ${colors.brand}` : `1.5px solid ${colors.line}`)};
  font-family: ${font.text};
  text-align: left;
  background: ${colors.surface};
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};
  transition: border-color 0.15s ease;

  &:hover:not(:disabled) {
    border-color: ${colors.brand};
  }

  svg {
    flex-shrink: 0;
    color: ${colors.muted};
    transform: rotate(${(props) => (props.$open ? "180deg" : "0deg")});
    transition: transform 0.2s ease;
  }
`;

export const TopTitle = styled.span`
  font-size: 15px;
  font-weight: ${(props) => (props.$placeholder ? 600 : 800)};
  color: ${(props) => (props.$placeholder ? colors.muted : colors.ink)};
`;
